import { CellTable } from "@/atoms"

export const ResourceCell = (
  value: {
    type: string
    displayName: string
    value: string[]
  }[]
) => {
  if (!value?.length) return CellTable("All Resources")

  const { type, displayName = type, value: resourceValues } = value[0]

  return CellTable(`${displayName}: ${resourceValues.join(", ")}`)
}
